<div class="header">
    <a href="/">
        <div class="header-brand">
            <div class="brand-logo">
                <img src="../../../../assets/img/viessmann-white.svg" alt="Viessmann Logo" />
            </div>
            <div class="brand-title">
                {{ 'HEADER.APP_TITLE' | translate }}
            </div>
        </div></a
    >
    <div class="header-toolbar">
        <app-language-dropdown
            [selectedCountry]="appService.getLocation()"
            (languageChanged)="onLanguageChanged($event)"
            *ngIf="this.appService.availableLanguages.length"
        >
        </app-language-dropdown>

        <button mat-icon-button class="feedback-button" (click)="sendFeedback()">
            <img src="../../../../assets/icons/feedback.svg" />
        </button>
        <a mat-icon-button [href]="faqLink" target="_blank">
            <mat-icon>help_outline</mat-icon>
        </a>
        <vih-app-switcher></vih-app-switcher>
        <vih-login [appManagesAuthentication]="true" [authenticated]="authenticated$"></vih-login>
    </div>
</div>
